
"use client"

import { Button, Col, InputNumber, Row } from "antd"

import Title from "@/components/common/Typography/Title"
import Text from "@/components/common/Typography/Text"
import { MinusOutlined, PlusOutlined } from "@ant-design/icons"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { useHotelSearchUrlSync } from "@/hooks/hotel/useHotelSearchUrlSync"
import { clampHotelRoomsNum, MAX_HOTEL_ROOMS_NUM } from "@/utils/hotel/hotelGuestCounts"
import { useTranslation } from "react-i18next"

const InputRoom = () => {
  const value = useAppSelector(state => state.hotel.formSearch.roomsNum || 0)
  const isDesktop = useIsDesktop()
  const dispatch = useAppDispatch()
  const syncHotelSearchUrl = useHotelSearchUrlSync()
  const { t } = useTranslation()
  const setValue = (val: any) => {
    dispatch(hotelActions.updateRooms(clampHotelRoomsNum(val)))
    syncHotelSearchUrl()
  }

  return (
    <Row gutter={[50, 10]} style={{ marginBlock: '1.6rem' }} justify='space-between' align='middle'>
      <Col>
        <Row>
          <Title level={isDesktop ? 4 : 5} style={{ margin: 0 }}>{t("hotel.room")}</Title>
        </Row>
        <Row>
          <Text type='secondary'>{' '}</Text>
        </Row>
      </Col>
      <Col>
        <Row align='middle' gutter={[5, 5]}>
          <Col>
            <Button disabled={value <= 1} onClick={() => setValue(value - 1)} size='large' shape='circle' icon={<MinusOutlined />} />
          </Col>
          <Col>
            <InputNumber
              min={1}
              max={MAX_HOTEL_ROOMS_NUM}
              onChange={(v) => setValue(v || 1)}
              value={value} variant='borderless'
              controls={false} size='large'
              style={{ maxWidth: 45 }}
            />
          </Col>
          <Col>
            <Button disabled={value >= MAX_HOTEL_ROOMS_NUM} onClick={() => setValue(value + 1)} size='large' shape='circle' icon={<PlusOutlined />} />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default InputRoom